module.exports = __webpack_public_path__ + "static/media/2cb1c644-8c1e-4493-aaac-904d426ad38e.5351b50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/2cb1c644-8c1e-4493-aaac-904d426ad38e.png
// module id = 1449
// module chunks = 0